import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification"
export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 30000 }
  }

  connect() {
    this.startTimeout();
    this.element.addEventListener("mousedown", this.dragStart.bind(this));
    this.element.addEventListener("touchstart", this.dragStart.bind(this), { passive: true });
  }

  disconnect() {
    this.stopTimeout();
  }

  // Oculta la notificación
  hide() {
    this.stopTimeout();
    this.element.classList.add('transition-opacity', 'duration-300', 'ease-out', 'opacity-0');
    if (this.isDragging) {
      const direction = Math.sign(this.currentX - this.startX);
      this.element.classList.add(direction > 0 ? 'translate-x-full' : '-translate-x-full');
    }
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  // Inicia el temporizador para auto-ocultar
  startTimeout() {
    this.stopTimeout(); // Asegura que no haya múltiples temporizadores
    this.timeout = setTimeout(() => this.hide(), this.dismissAfterValue);
  }

  // Detiene el temporizador
  stopTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  // --- Lógica de Arrastre ---

  dragStart(event) {
    this.isDragging = true;
    this.startX = event.pageX || event.touches[0].pageX;
    this.currentX = this.startX;
    this.stopTimeout();
    this.element.classList.remove('transition-opacity', 'duration-300', 'ease-out', 'opacity-0', 'translate-x-full', '-translate-x-full');
    this.dragMove = this.dragMove.bind(this);
    this.dragEnd = this.dragEnd.bind(this);
    window.addEventListener("mousemove", this.dragMove);
    window.addEventListener("touchmove", this.dragMove);
    window.addEventListener("mouseup", this.dragEnd);
    window.addEventListener("touchend", this.dragEnd);
  }

  dragMove(event) {
    if (!this.isDragging) return;
    this.currentX = event.pageX || event.touches[0].pageX;
    const deltaX = this.currentX - this.startX;
    this.element.style.transform = `translateX(${deltaX}px)`; // Only for drag, allowed for smoothness
  }

  dragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    const deltaX = this.currentX - this.startX;
    const threshold = this.element.offsetWidth * 0.5;
    if (Math.abs(deltaX) > threshold) {
      this.hide();
    } else {
      this.element.classList.remove('translate-x-full', '-translate-x-full');
      this.element.classList.add('transition-transform', 'duration-300', 'ease-out');
      this.element.style.transform = "translateX(0)";
      this.startTimeout();
    }
    window.removeEventListener("mousemove", this.dragMove);
    window.removeEventListener("touchmove", this.dragMove);
    window.removeEventListener("mouseup", this.dragEnd);
    window.removeEventListener("touchend", this.dragEnd);
  }
}
